import { useState, useEffect } from "react";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { Box, Grid2, Link, Stack, Typography, useTheme } from "@mui/material";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import { Radios } from "../../../../MainComponents/Radios/Radios";
import { InvestigationButton } from "../components";
import { returnIsValid } from "../Main/useConstants";
import { InputCatalogue } from "../../../../MainComponents/Catalogues/InputCatalogue";
import { catalogByPart } from "../../../../../apis";

// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (form) => {
  const { inside, location, center } = form;
  console.log(center)
  const errors = {};
  if (inside == null) {
    errors.inside = true;
  } else {
    if (!inside && location.trim() === "") {
      errors.location = true;
    }
    if (inside && center.trim() === "") {
      errors.center = true;
    }
  }
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
}

export const AddAndEditScenario = ({ scenarios, selectedScenario, setSelectedScenario, setIsEditing, handleSaveScenarios }) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();
  const [inside, setInside] = useState(null);
  const [location, setLocation] = useState("");
  const [details, setDetails] = useState("");
  const [area, setArea] = useState("");
  const [areaManual, setAreaManual] = useState("");
  const [subarea, setSubarea] = useState("");
  const [center, setCenter] = useState("");
  const [activeDetails, setActiveDetails] = useState(false);
  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});
  const [areaOptions, setAreaOptions] = useState([]);

  useEffect(() => {
    if (selectedScenario != null) {
      const currentScenario = scenarios[selectedScenario];
      setInside(currentScenario.inside ?? null);
      setLocation(currentScenario.location ?? "");
      setCenter(currentScenario.center ?? "");
      setDetails(currentScenario.details ?? "");
      setArea(currentScenario.area ?? "");
      setAreaManual(currentScenario.area_manual ?? "");
      setSubarea(currentScenario.subarea ?? "");
      setActiveDetails(!!currentScenario.details ?? false);
    }
  }, [selectedScenario]);

  // Cargar opciones del catálogo investigatingArea
  useEffect(() => {
    const loadAreaOptions = async () => {
      try {
        const response = await catalogByPart({
          catalogue: "investigatingArea",
          is_own: true,
          path: "/"
        });
        if (response?.data) {
          const options = response.data.map((item) => ({
            label: item.label,
            value: item.path_locales,
          }));
          setAreaOptions(options);
        }
      } catch (error) {
        console.error("Error loading investigating area catalogue:", error);
        setAreaOptions([]);
      }
    };

    loadAreaOptions();
  }, []);

  useEffect(() => {
    if (triedToSave) {
      const [_, errors] = validateForm({ inside, location, center });
      setErrors(errors);
    }
  }, [inside, location, center]);

  const handleChangeInside = (value) => {
    if (value === "false") setInside(false);
    if (value === "true") setInside(true);
    // setErrors({});
    // setTriedToSave(false);
  }

  const handleClose = () => {
    setSelectedScenario(null);
    setIsEditing(false);
  }

  const handleSave = async () => {
    const newCenter = inside ? center : "";
    const newLocation = !inside ? location : "";
    const newArea = inside ? area : "";
    const newAreaManual = inside ? areaManual : "";
    const newSubarea = inside ? subarea : "";

    const scenario = {
      inside,
      location: newLocation,
      details,
      center: newCenter,
      area: newArea,
      area_manual: newAreaManual,
      subarea: newSubarea,
      ...(inside && { catalogue: "business_units" }),
    };

    const [isValid, errors] = validateForm(scenario);
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("missing_required_inputs") });
      return;
    };

    if (selectedScenario != null) {
      const newScenarios = _.cloneDeep(scenarios);
      newScenarios[selectedScenario] = scenario;
      await handleSaveScenarios(newScenarios);
    } else {
      await handleSaveScenarios([...scenarios, scenario]);
    }
    handleClose();
  }

  const eventsPlaceOptions = [
    {
      value: true,
      label: t("locations.location_inside_the_work_center_check"),
    },
    {
      value: false,
      label: t("locations.location_outside_the_work_center_check"),
    },
  ]

  return (
    <>
      <Box padding={2}>
        <Box display="flex" alignItems="center" marginBottom={1.5}>
          <Typography
            fontWeight={600}
            fontSize={16}
            color={theme.palette.ethicsBlue.main}
          >
            {selectedScenario != null ? t("locations.edit_location") : t("locations.add_new_location")}
          </Typography>
          <Box
            flexGrow={1}
            height="1px"
            sx={{
              backgroundColor: theme.palette.ethicsBlue.main,
              marginLeft: 1
            }}
          />
        </Box>

        <Grid2 container spacing={2} marginBottom={activeDetails ? 2 : 0} alignItems="center">
          <Grid2 size={{ xs: 12, lg: 6 }} >
            <Radios
              value={inside}
              onChangue={handleChangeInside}
              text={t("locations.where_happened_the_facts")}
              required={true}
              helpText={t("locations.help_text")}
              options={eventsPlaceOptions}
              isValid={returnIsValid(errors?.inside, triedToSave) ?? null}
              showSuccessValidation={true}
              row
            />
          </Grid2>

          {
            inside === false &&
            <Grid2 size={{ xs: 12, lg: 6 }}>
              <EGInput
                label={t("locations.location")}
                value={location}
                name="location"
                onChange={(e) => setLocation(e.target.value)}
                required={true}
                isValid={returnIsValid(errors?.location, triedToSave) ?? null}
                showSuccessValidation
                showHelpText={false}
              />
            </Grid2>
          }

          {
            inside === true &&
            <InputCatalogue
              defaultValue={center}
              catalogue={"business_units"}
              isOwn={true}
              onChange={setCenter}
              isValid={returnIsValid(errors?.center, triedToSave) ?? null}
              wrapper={<Grid2 size={{ xs: 12, lg: 6 }} />}
            />
          }
        </Grid2>

        {
          inside != null &&
          <>

            {activeDetails &&
              <>
                <Box display="flex" justifyContent={activeDetails ? "flex-start" : "flex-end"} sx={{ marginBottom: 2 }}>
                  <EGBasicSelect
                    label={t("locations.area")}
                    value={area}
                    options={areaOptions}
                    onChange={(e) => setArea(e.target.value)}
                  />
                </Box>

                <Grid2 container spacing={2} sx={{ marginBottom: 2 }}>
                  <Grid2 size={{ xs: 12, lg: 6 }}>
                    <EGInput
                      label={t("locations.area_manual")}
                      value={areaManual}
                      onChange={(e) => setAreaManual(e.target.value)}
                      showHelpText={false}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, lg: 6 }}>
                    <EGInput
                      label={t("locations.subarea")}
                      value={subarea}
                      onChange={(e) => setSubarea(e.target.value)}
                      showHelpText={false}
                    />
                  </Grid2>
                </Grid2>
              </>
            }

            <Box display="flex" justifyContent={activeDetails ? "flex-start" : "flex-end"}>
              {
                activeDetails ? (
                  <EGInput
                    label={t("locations.details")}
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    type="textarea"
                    multiline
                    rows={5}
                    sx={{ marginBottom: 2 }}
                  />
                ) : (
                  <Link
                    onClick={() => setActiveDetails(true)}
                    underline="hover"
                    textAlign="end"
                    sx={{ marginBottom: 2 }}
                  >
                    + {t("locations.add_details")}
                  </Link>
                )
              }
            </Box>


          </>
        }





        <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1}>
          <InvestigationButton
            label={t("locations.cancel")}
            icon="close_icon"
            size="medium"
            onClick={handleClose}
          />
          <InvestigationButton
            label={t("locations.save")}
            variant="success"
            size="medium"
            icon="mark_check_bold"
            onClick={handleSave}
          />
        </Stack>
      </Box>
    </>
  )
}